import { inject, Injectable } from '@angular/core';
import { UuidService } from '../shared/services/uuid.service';
import { SaveLocalService } from '../shared/services/data-store/save-local.service';
import { RemovalSaveInfoViewModel } from '../shared/viewmodels/shared/removal-save-info.viewmodel';
import { RemovalViewModel } from '../shared/viewmodels/shared/removal.viewmodel';

interface RemovalRow {
  date?: string | null;
  pen?: string | null;
  numberOfAnimals?: string | number | null;
  weight?: string | number | null;
  code?: string | null;
  reason?: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class RemovalsService {
  private readonly saveLocalService = inject(SaveLocalService);
  private readonly uuidService = inject(UuidService);

  getRemovals(): ReadonlyArray<never> {
    return [];
  }

  saveRemovals(removals: ReadonlyArray<RemovalRow>): void {
    const removalsSaveInfos: RemovalSaveInfoViewModel[] = removals
      .filter((row): row is RemovalRow => row !== undefined && row !== null)
      .map((row) => new RemovalSaveInfoViewModel(
        this.uuidService.getNewUuid(),
        new RemovalViewModel(
          row.date ? new Date(row.date) : new Date(),
          String(row.pen ?? '').trim(),
          Number(row.numberOfAnimals ?? 0),
          Number(row.weight ?? 0),
          String(row.code ?? ''),
          String(row.reason ?? '')
        )
      ));

    this.saveLocalService.saveRemovals(removalsSaveInfos);
  }
}
